import React, { useEffect, useState } from "react";
import * as S from "./styles";

import IconDoc from "../../../assets/icons/icon-copy.svg";
import IconClock from "../../../assets/icons/icon-clock.svg";
import local from "../../../assets/icons/icon-location.svg";
import IconWarning from "../../../assets/icons/icon-warning-orange.png";
import api from "../../../services/api";
import Tooltip from "../../tooltip";
import { openCulturaUrl } from "../../../utils/culturasPdf";
import { BodyG, H6, TaglineM, TaglineP } from "../../../styles/stylesTypography";
import { theme } from "../../../styles/theme";

const LastRecipesHome = () => {
  const [allRecipes, setAllRecipes] = useState([]);

  const getAllRecipes = async () => {
    try {
      const response = await api.get("/home/receitas-emitidas");
      setAllRecipes(response.data.data);
    } catch (error) {
    }
  };

  const formatDate = (dateISO) => {
    const date = new Date(dateISO);

    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('pt-BR', { month: 'short' }).toUpperCase().replace('.', '');
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  };


  useEffect(() => {
    getAllRecipes();
  }, []);

  return (
    <S.Container>
      <S.HeaderContainer>
        <S.ContainerWrapperPrimary>
          <BodyG color={theme.colors.gray.Cinza_2} fontWeight={700}>Últimas receitas</BodyG>
        </S.ContainerWrapperPrimary>

        <S.ContainerWrapperSecondary>
          <a onClick={() => window.location = "/historico"}>
            <img src={IconClock} alt="Ícone de relógio" />

            <TaglineM color={theme.colors.blue.Azul_link} fontWeight={800}>Ver Histórico</TaglineM>
          </a>

          <S.NewRecipe onClick={() => (window.location = "/receitas/add")}>
            <img src={IconDoc} alt="Ícone de Documento" />

            <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800}>Emitir nova receita</TaglineM>
          </S.NewRecipe>
        </S.ContainerWrapperSecondary>
      </S.HeaderContainer>

      <S.BoxesWrapper>
        {allRecipes.map((data, index) => {
          const ishomolog = data.homologado

          return (
            <S.Boxes key={index} onClick={() => window.open(data.receita, "_blank")}>
              <S.HeaderBoxes>
                <H6 color={theme.colors.gray.Cinza_2}>{data.produtos[0]}</H6>
                <Tooltip content={"Não enviado para o estado"} animation="fade" delay={[300, 100]} arrow={true} theme="light" placement="bottom">
                  {!ishomolog && (
                    <img src={IconWarning} alt="Ícone de aviso" width={16} height={16} />
                  )}
                </Tooltip>
              </S.HeaderBoxes>

              <S.FooterBoxes>
                <S.CropBadge
                  style={{ cursor: "pointer" }}
                  onClick={(e) => { e.stopPropagation(); openCulturaUrl(data.cultura); }}
                >
                  <TaglineP color={theme.colors.white.Branco} fontWeight={800}>
                    {data.cultura}
                  </TaglineP>
                </S.CropBadge>

                <TaglineP color={theme.colors.gray.Cinza_2}>
                  {formatDate(data.data_emissao)}
                </TaglineP>
              </S.FooterBoxes>

              <S.BelowFooter>
                <Tooltip content={data.fazenda_nome} animation="fade" delay={[300, 100]} arrow={true} theme="light" placement="bottom">
                  <S.FarmLocation>
                    <img src={local} alt="Ícone de localização" />

                    <TaglineP color={theme.colors.blue.Azul_link} fontWeight={800}>
                      {data.fazenda_nome}
                    </TaglineP>
                  </S.FarmLocation>
                </Tooltip>

                {/* Avatar com fundo preto e iniciais da fazenda */}
                <Tooltip content={data.produtor_nome} animation="fade" delay={[300, 100]} arrow={true} theme="light" placement="bottom">
                  <S.ProfilePlaceholder>
                    {data.produtor_nome
                      .split(' ')
                      .filter(name => name.length > 0)
                      .map((word, index, array) =>
                        array.length === 1 ? word.substring(0, 2) : (index < 2 ? word[0] : '')
                      )
                      .join('')
                      .toUpperCase()}
                  </S.ProfilePlaceholder>
                </Tooltip>
              </S.BelowFooter>
            </S.Boxes>
          )
        })}
      </S.BoxesWrapper>
    </S.Container>
  );
};

export default LastRecipesHome;
